import { isArray } from 'lodash';

export function compareWithArrayCopy(src: any[], dest: any[]) {
  if (isArray(src)) {
    return dest;
  }
}
